import { IIdentity } from '../views/Settings'
import { DataPanel } from './DataPanel'
import { DataTable } from './DataTable'
interface NodeSettingsProps {
    data: IIdentity
}

const NodeSettings = ({ data }: NodeSettingsProps) => {
    return (
        <>
            <DataPanel
                title="Information"
                minHeight={200}
                content={
                    <DataTable
                        isPrivateDataAvailable={false}
                        data={[
                            {
                                key: 'Decentralized Identity',
                                value: data?.did,
                                private: false,
                            },
                            {
                                key: 'Node Name',
                                value: data?.displayName,
                                private: false,
                            },
                            {
                                key: 'Network Interchange ID',
                                value: data?.interchangeId,
                                private: false,
                            },
                            {
                                key: 'Tax Identification Number',
                                value: data?.etin,
                                private: false,
                            },
                            {
                                key: 'National Provider Identifier (NPI)',
                                value: data?.npi,
                                private: false,
                            },
                            {
                                key: 'Group National Provider Identifier (NPI)',
                                value: data?.groupNpi,
                                private: false,
                            },
                            {
                                key: 'Node Type',
                                value: (data?.type ?? '').toUpperCase(),
                                private: false,
                            },
                        ]}
                    />
                }
            />
        </>
    )
}

export default NodeSettings
